import styled from 'styled-components';

const HeaderContainer = styled.div`
  height: 120px;
  box-shadow: 0px 1px 6px 1px #00000026;
  .description {
    .Superops-TextField__Input {
      color: #00000099 !important;
    }
  }
`;

export { HeaderContainer };
